import React from 'react'
import logo from '../assets/images/logo.png'
import { useAuth } from '../context/AuthContext'
import { Link, useNavigate } from 'react-router-dom'
import AuthApis from '../queries/auth'
function Footer() {
    const { isAuthenticated } = useAuth()
    const navigate = useNavigate()
    const { data: CompanyDetails } = AuthApis.GetcompanyDetails()

    return (
        <footer className="footer_section">
            <div className="container">
                <div className="row">
                    <div className="col-md-3">
                        <div className="footer_box">
                            <div className="footer_box_head"><img src="/images/CareTeam-Logo-Final-1_page-0001-removebg-preview.png" alt="" className='w-50' /></div>
                            <p>
                                Empowering transformation and success through tailored training and resources. The Care Team is your partner in unlocking potential and achieving growth.
                            </p>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="footer_box">
                            <div className="footer_box_head">Resources</div>
                            <ul>
                                <li>
                                    {
                                        isAuthenticated ?
                                            <Link to='/my-account'>Home</Link>
                                            :
                                            <Link to='/'>Home</Link>
                                    }

                                </li>
                                <li><Link to='/categories'>Categories</Link></li>
                                <li><Link to='/courses'>Courses</Link></li>
                                <li><Link to="/contact-us">Contact Us</Link></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="footer_box">
                            <div className="footer_box_head">Quick links</div>
                            <ul>
                                {
                                    isAuthenticated ?
                                        <li><Link to="/my-learnings">My Learnings</Link></li>
                                        :
                                        <>
                                            <li><Link to="/login">Login</Link></li>
                                            <li><Link to="/register">Register</Link></li>
                                        </>

                                }


                            </ul>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="footer_box">
                            <div className="footer_box_head">Connect with Us</div>
                            <ul>
                                <li><span><i className="fa-brands fa-facebook"></i></span> <a href={CompanyDetails?.data?.facebook}>Facebook</a></li>
                                <li><span><i className="fa-brands fa-x-twitter"></i></span> <a href={CompanyDetails?.data?.twitter}>Twitter</a></li>
                                <li><span><i className="fa-brands fa-linkedin-in"></i></span> <a href={CompanyDetails?.data?.linkedin}>LInkedIn</a></li>
                                <li><span><i className="fa-brands fa-youtube"></i></span> <a href={CompanyDetails?.data?.youtube}>YouTube</a></li>
                                <li><span><i className="fa-brands fa-instagram"></i></span> <a href={CompanyDetails?.data?.instagram}>Instagram</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer_copyright" >
                <div className="container">
                    <div className="footer_copyright_cnt">
                        <span >Copyright @ The Care Team. All rights reserved.
                            <br/>Unleashing Potentials, One Code at a Time.
                        </span>
                        <span>
                            <a href="#">Terms and Condition</a>
                            <a href="#">Privacy Policy</a>
                        </span>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer